import { defineMessages } from "@/lib/i18n/messages";

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export default defineMessages({
  es: {
    seasons: (n: number) => plural(n, "temporada", "temporadas"),
    episodes: (n: number) => plural(n, "episodio", "episodios"),
    searchOn: (provider: string) => `Buscar en ${provider}`,
    whereToWatch: "Ver dónde verla",
  },
  en: {
    seasons: (n: number) => plural(n, "season", "seasons"),
    episodes: (n: number) => plural(n, "episode", "episodes"),
    searchOn: (provider: string) => `Search on ${provider}`,
    whereToWatch: "See where to watch",
  },
});
